import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { LinkProps } from '@swf/components/Link/Link';
import Link from '@swf/components/Link/Link';
import type { TranslationTag } from '@swf/core/types/i18n';
import { Icon } from '@swf/sports/components';

import styles from './AllItemsLink.scss';

interface Props extends Pick<LinkProps, 'values' | 'alias'> {
  translation: TranslationTag;
}

const AllItemsLink: React.FC<Props> = ({ translation, values, alias }) => (
  <Link className={styles.allItemsLink} alias={alias} values={values}>
    <Translation {...translation} />
    <Icon name="chevron-small-right" size="xl" />
  </Link>
);

export default AllItemsLink;
